import React, { useContext, useEffect, useState } from "react";
import {
  Grid,
  Box,
  Container,
  CircularProgress,
  Typography,
  Button,
  FormControl,
  makeStyles,
  FormHelperText,
  MenuItem,
  InputLabel,
  Select,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";
import { Form, Formik } from "formik";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import Axios from "axios";
import PageTitle from "../../components/PageTitle";
import ApiConfig from "../../config/ApiConfig";
import { DropzoneArea } from "material-ui-dropzone";
import DeleteIcon from '@material-ui/icons/Delete';
import CircularProgressWithBackdrop from "../../components/Loader/loader";
import Widget from "../../components/Widget/Widget";


const useStyles = makeStyles((theme) => ({
  main: {
    width: "90%",
    display: "flex",
    flexDirection: 'column',
    gap: '15px',
    justifyContent: "center",
    alignItems: 'center'
  },
  editInput: {
    position: "absolute",
    zIndex: "1000",
    opacity: "0",
    cursor: "pointer",
    right: "0",
    top: "0",
    height: "100%",
    fontSize: "24px",
    width: "100%",
  },
  imgUploadDiv: {
    height: "200px",
    width: "200px",

    position: "relative",
    overflow: "hidden",
  },
  tableButton: {
    borderRadius: " 8px",
    background: " var(--Primary, #00AFEE)",
  },
  colorbox1: {
    width: '100%',
    "& .MuiGrid-container": {
      display: "block !important",
    },
    "& .MuiGrid-grid-xs-4": {
      maxWidth: "100%",
    },
    "& .MuiDropzoneArea-textContainer": {
      display: "none",
    },
    "& .MuiDropzonePreviewList-image": {
      height: "100%",
      maxHeight: '300px'
    },
    "& .MuiDropzonePreviewList-removeButton": {
      display: "block",
    },
    "& .MuiDropzonePreviewList-removeButton": {
      top: "31px",
      right: "35px",
      width: "40px",
      height: "40px",
      opacity: 0,
      position: "absolute",
      transition: ".5s ease",
    },
    "& .MuiDropzoneArea-root": {

      border: 'none',
      borderRadius: '15px'
    }


  },
  colorbox: {
    width: '100%',
    "& .MuiGrid-container": {
      display: "block !important",
    },
    "& .MuiGrid-grid-xs-4": {
      maxWidth: "100%",
    },
    "& .MuiDropzoneArea-textContainer": {
      display: "block !important",
    },

    "& .MuiDropzonePreviewList-removeButton": {
      display: "block",
    },
    "& .MuiDropzonePreviewList-removeButton": {
      top: "31px",
      right: "35px",
      width: "40px",
      height: "40px",
      opacity: 0,
      position: "absolute",
      transition: ".5s ease",
    },
    "& .MuiDropzoneArea-root": {

      border: 'none',
      borderRadius: '15px'
    }
  },
  drop: {

  },
}));
function Editprofile() {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [profileImage, setProfileImage] = useState('');
  const [image, setImage] = useState('');
  let email = window.localStorage.getItem("email");
  const [imgLink, setImgLink] = useState('')
  const [profileData, setProfileData] = useState([]);
  const [imagePreview,setImagePreview] = useState("");
   const [testIMG, setTestIMG] = useState(null);
   const [formInitialSchema, setFormInitialSchema] = useState({
    firstname: "",
    lastname: "",
    email: email,
  });

  // console.log(profileData?.firstName,"profileDataprofileData");
  

  // const formInitialSchema = {
  //   firstname: profileData?.firstName || profileData?.fullName || "",
  //   lastname: profileData?.lastName ||  "",
  //   email: email,
  // }; 


  console.log(formInitialSchema,"formInitialSchema")
  const myProfile = async () => {
    try {
      const res = await Axios({
        method: "GET",
        url: ApiConfig.myProfile,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
          userId: window.localStorage.getItem("userId"),
        },
      });

      if (res?.data?.status == 200) {
        console.log(res?.data?.data?.imageUrl);
        setImgLink(res?.data?.data?.imageUrl);
        setImagePreview(res?.data?.data?.imageUrl)
        setProfileData(res?.data?.data)

        const { firstname, lastname } = splitFullName(res?.data?.data.fullName);
        
        setFormInitialSchema({
          firstname: firstname,
          lastname: lastname,
          email: email,
        });

      }
    } catch (error) {
    }
  };

  useEffect(() => {
    myProfile();
  }, []);

  const handleFormSubmit = async (values) => {

    if (!values.firstname || !values.lastname) {
      toast.error("Please enter First Name and Last Name");
      return;
    }
    const token = window.localStorage.getItem("id_token");
    try {
      const res = await Axios({
        method: "POST",
        url: ApiConfig.editProfile,
        headers: {
          Authorization: `Bearer ${token}`,
          userId: window.localStorage.getItem("userId"),
        },
        data: {
          // firstName: values.firstname,
          fullname:`${values.firstname} ${values.lastname}`,
          imageUrl: profileImage || imgLink,
          // lastName: values.lastname,
        }
      });

      if (res.data.status === 200) {
        toast.success(res.data.message);
        history.push("/app/my-account");
      }
    } catch (error) { }
  };

  const validationSchema = yup.object().shape({
    firstname: yup
    .string()
    .required("Please enter First Name.")
    .min(3, 'First name must be at least 3 characters.')
    .max(30, "First Name must be at most 30 characters.")
    .matches(/^[a-zA-Z]{3,50}$/, "Please enter only alphabetical characters."),
  lastname: yup
    .string()
    .required("Please enter Last Name.")
    .min(3, 'last name must be at least 3 characters.')
    .max(30, "Last Name must be at most 30 characters.")
    .matches(/^[a-zA-Z]{3,50}$/, "Please enter only alphabetical characters."),
  
    email: yup
      .string()
      .email("Please enter a valid email address.")
      .required("Please enter your email address.")
      .max(255, "Email address should be less than 255 characters.")
      .matches(
        /^(?!.*\.\.)(?!.*[@.]$)[a-zA-Z0-9][a-zA-Z0-9._+-]{0,252}@[a-zA-Z0-9-]{2,63}(\.[a-zA-Z]{2,63}){1,2}$/,
        "Please enter a valid email address."
      ),
  });

  const handleDrop = (files) => {
    if (files.length > 0) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const imageData = e.target.result;
        setImagePreview(imageData); 
        setTestIMG(imageData);       
        uploadIMG(imageData); 
      };
      reader.readAsDataURL(files[0]);
    }
  };

  const uploadIMG = async (imageData) => { // Accept imageData as parameter
    if (!imageData) {
      toast.error("No image selected");
      return;
    }
  
    setLoader(true);
    try {
      const base64Data = imageData.includes(',') ? 
        imageData.split(',')[1] : 
        imageData.replace(/^data:image\/\w+;base64,/, '');
      
      const res = await Axios({
        method: "POST",
        url: ApiConfig.uploadImage,
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("id_token")}`,
          'Content-Type': 'application/json'
        },
        data: [base64Data]
      });
  
      if (res.data.status === 200) {
        setProfileImage(res.data.data[0]);
        toast.success("Image uploaded successfully");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to upload image");
    } finally {
      setLoader(false);
    }
  };

  const splitFullName = (fullName) => {
    if (!fullName) return { firstname: "", lastname: "" };
    
    const nameParts = fullName.trim().split(/\s+/);
    return {
      firstname: nameParts[0] || "",
      lastname: nameParts.slice(1).join(' ') || ""
    };
  };


  console.log(imgLink)
  return (
    <>
      <PageTitle title="Edit Profile" />
      <Container maxWidth="sm">
        <Widget>
          <Formik
            enableReinitialize={true}
            onSubmit={(values) => handleFormSubmit(values)}
            initialValues={formInitialSchema}
            validationSchema={validationSchema}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              touched,
              values,
              setFieldValue,
            }) => (
              <Form>
                <Grid container spacing={4} justifyContent="center">
                  <Grid item xs={12} align="center">
                    <Box mb={3}>
                      <label className={classes.label} style={{ fontSize: 18, fontWeight: 600 }}>
                        Change Profile Photo <span style={{ color: "red" }}>*</span>
                      </label>
                    </Box>
                    {loader ? (
                      <CircularProgressWithBackdrop open={loader} />
                    ) : (
                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {imagePreview ? (
                          <Box style={{ position: "relative", height: "180px", width: "180px", marginBottom: 16 }}>
                            <img
                              src={imagePreview}
                              height="100%"
                              width="100%"
                              alt="Profile Preview"
                              style={{ borderRadius: "50%", objectFit: "cover", border: "2px solid #eee" }}
                            />
                            <Typography
                              style={{ position: "absolute", right: "10px", color: "grey", top: "10px", cursor: "pointer" }}
                              onClick={() => setImagePreview("")}
                            >
                              <DeleteIcon />
                            </Typography>
                          </Box>
                        ) : (
                          <DropzoneArea
                            classes={classes.DropzoneArea}
                            acceptedFiles={['image/*']}
                            maxFileSize={5000000}
                            maxFiles={1}
                            onDrop={handleDrop}
                            dropzoneText="Drag and drop or click to select a profile image"
                          />
                        )}
                      </Box>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Box mb={2}>
                      <label className={classes.label} style={{ fontWeight: 500 }}>
                        First Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <TextField
                        placeholder="First name"
                        type="text"
                        variant="outlined"
                        fullWidth
                        name="firstname"
                        value={values.firstname}
                        onBlur={handleBlur}
                        error={touched.firstname && !!errors.firstname}
                        helperText={touched.firstname && errors.firstname}
                        className={classes.textFeilds}
                        onChange={handleChange}
                        InputProps={{
                          className: classes.TextBox,
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box mb={2}>
                      <label className={classes.label} style={{ fontWeight: 500 }}>
                        Last Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <TextField
                        placeholder="Last name"
                        type="text"
                        variant="outlined"
                        fullWidth
                        name="lastname"
                        value={values.lastname}
                        onBlur={handleBlur}
                        error={touched.lastname && !!errors.lastname}
                        helperText={touched.lastname && errors.lastname}
                        className={classes.textFeilds}
                        onChange={handleChange}
                        InputProps={{
                          className: classes.TextBox,
                        }}
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box mb={2}>
                      <label className={classes.label} style={{ fontWeight: 500 }}>
                        Email Id <span style={{ color: "red" }}>*</span>
                      </label>
                      <TextField
                        placeholder="Email Id"
                        type="text"
                        variant="outlined"
                        fullWidth
                        name="email"
                        value={values.email}
                        onBlur={handleBlur}
                        error={touched.email && !!errors.email}
                        helperText={touched.email && errors.email}
                        className={classes.textFeilds}
                        onChange={handleChange}
                        InputProps={{
                          className: classes.TextBox,
                        }}
                        disabled
                      />
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          fullWidth
                          className={classes.tableButton}
                          style={{ fontWeight: 600 }}
                        >
                          Update
                        </Button>
                      </Grid>
                      <Grid item xs={6}>
                        <Button
                          variant="outlined"
                          fullWidth
                          className={classes.tableButton}
                          style={{ fontWeight: 600 }}
                          // onClick={() => handleBack()}
                        >
                          Cancel
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Widget>
      </Container>
    </>
  );
}
export default Editprofile;
